import React from "react";
import AllDeliveryOrders from "./DeliveryOrdersModule/AllDeliveryOrders";

const DeliveryOrders = () => {
  return (
    <div>
      <AllDeliveryOrders />
    </div>
  );
};

export default DeliveryOrders;
